// extracted by mini-css-extract-plugin
export var articleMultipleChoiceCTA = "cn_hZ";
export var mainHeader = "cn_jz";